.field-card {
    cursor: grab;
}

.field-card--in-drag-overlay {
    cursor: grabbing;
}

.field-card--disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.drag-handle-container {
    transform: rotate(90deg);
}
